import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-5 leading-tight tracking-tight">
          Stop Staring at Dashboards.
          <span className="block mt-1 bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
            Start Closing the Right Deals.
          </span>
        </h2>
        
        <p className="text-base text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
          Join the next wave of GTM teams replacing spreadsheet backchannels and tool fatigue with a true Revenue OS, one that tells your reps exactly what to do next, and proves its ROI in weeks.
        </p>

        <a 
          href="https://calendar.app.google/nswB9pt6ALLZ8xoy7" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white px-8 py-3.5 text-sm font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
        >
          Book Your Revenue OS Briefing
          <ArrowRight className="ml-2 h-4 w-4" />
        </a>
      </div>
    </section>
  );
};

export default CTASection;
